// utils/connectionError.js
// ============================================
// The error a page receives when an ACTION (POST / PUT / PATCH / DELETE)
// could not reach the server.
//
// Read requests never see this: apiFetch holds a GET until the connection is
// back and then completes it (see context/AuthContext.js). A write is never
// replayed automatically — doing it twice could duplicate a payroll run or a
// request — so it fails, but with a clear bilingual message instead of the
// browser's raw "TypeError: Failed to fetch". Pages that show `err.message`
// get the professional text without any change of their own.
// ============================================

const MESSAGES = {
  en: "Couldn't reach Nexploy, so this action wasn't completed. Check your connection and try again.",
  ar: "تعذّر الوصول إلى Nexploy، لذلك لم تكتمل هذه العملية. تحقق من اتصالك وحاول مرة أخرى.",
};

const currentLanguage = () => {
  try {
    return localStorage.getItem("language") === "ar" ? "ar" : "en";
  } catch (err) {
    return "en";
  }
};

export class ConnectionError extends Error {
  constructor(cause) {
    super(MESSAGES[currentLanguage()]);
    this.name = "ConnectionError";
    this.code = "NETWORK_UNAVAILABLE";
    this.isConnectionError = true;
    if (cause) this.cause = cause;
  }
}

export const isConnectionError = (err) => Boolean(err && err.isConnectionError);

/** The text pages should show for a connection failure, in a given language. */
export const connectionErrorMessage = (language) => MESSAGES[language === "ar" ? "ar" : "en"];
